import get from 'lodash/get';
import { createSelector } from 'reselect';

/**
 *
 * @param {import('../../index').TState} state
 */
const getTariffs = ({ bundles }) => get(bundles, 'tariffs.byId');
export const getTariffsSelector = createSelector(
    [getTariffs],
    tariffs => [...Object.values(tariffs)],
);

export const getTariffChannels = (state) => {
    const isActiveFilter = state.bundles.channelsFiltersIsApply;
    return isActiveFilter ? state.bundles.filteredChannels : state.bundles.tariffChannels;
};

export const getTariffChannelsWithId = createSelector(
    state => getTariffChannels(state),
    channels => channels.map(channel => ({
        ...channel,
        id: channel.xvid,
    })),
);

